import { Alert, Conditional } from '@consumidor-positivo/aurora';

import { SHOffer } from '../../../../../services/sortingHat';
import { UserType } from '../../../../../types';

import { MMCard } from '../../../components/MMCard';
import { MMCardSkeleton } from '../../../components/MMCardSkeleton';
import { CreditCarousel } from '../../../../../components/CreditCarousel';

type ResultCarouselProps = {
  isLoading: boolean;
  offers: SHOffer[];
  user: UserType;
};

export const ResultCarousel = ({ isLoading, offers, user }: ResultCarouselProps) => {
  const noOffers = !isLoading && offers && offers.length === 0;
  const resultOffers = isLoading ? ([{}, {}, {}] as SHOffer[]) : offers;

  // FIXME: Handle emptyState
  if (noOffers) {
    return <Alert type={1} status="error" title={{ content: 'Ops, algo deu errado!', weight: 'bold' }} text="Tente novamente mais tarde." />;
  }

  return (
    <CreditCarousel>
      {resultOffers.map((item, index) => (
        <Conditional
          key={`result-offer-${index}`}
          condition={isLoading}
          renderIf={<MMCardSkeleton position={index + 1} />}
          renderElse={<MMCard user={user} offer={item} position={index} />}
        />
      ))}
    </CreditCarousel>
  );
};
